export const getHotelRoomRepartitionLabel = (
  hotelRepartition: number[],
  ageLimits: Array<{ childAgeFrom?: number; childAgeTo?: number }>,
) => {
  if (!hotelRepartition || hotelRepartition.length === 0) return '';
  let label = `${hotelRepartition[0]} adulte`;
  if (hotelRepartition[0] > 1) label += 's';
  if (hotelRepartition.length > 2 && hotelRepartition[2] > 0) {
    label += ` & ${hotelRepartition[2]} enfant`;
    if (hotelRepartition[2] > 1) label += 's';
    if (
      ageLimits.length > 1 &&
      ageLimits[1].childAgeFrom !== undefined &&
      ageLimits[1].childAgeTo !== undefined
    )
      label += ` (${ageLimits[1].childAgeFrom}-${ageLimits[1].childAgeTo})`;
  }
  if (hotelRepartition.length > 1 && hotelRepartition[1] > 0) {
    label += ` & ${hotelRepartition[1]} enfant`;
    if (hotelRepartition[1] > 1) label += 's';
    if (
      ageLimits.length > 0 &&
      ageLimits[0].childAgeFrom !== undefined &&
      ageLimits[0].childAgeTo !== undefined
    )
      label += ` (${ageLimits[0].childAgeFrom}-${ageLimits[0].childAgeTo})`;
  }
  return label;
};
